
export const LogStatusUIds = {
  SubscriptionCheckFailed: '51e2de2c-f976-4fe7-a2ea-79a90e0fe3f4',
  DoNotDisturbInEffect: '2b7af128-821f-4952-acfc-d6587ddcfa22',
  AddressWasRemovedByPrefs: '99cc157d-011f-4366-8b65-bb4f21a62334',
  RuleNotificationDeleted: '83fa3b03-8457-4d03-908f-016eba7bd1d8',
};

